import * as constants from './metaData-constants';
import Promise from 'bluebird';
import { get, post, put, del } from '../../../utils/http';
import checkStatus from '../../../utils/checkStatus';
import R from 'ramda';

export const getMetadata = () => (dispatch, getState) => {
  return Promise.all([
    get('/proxy/newsfeed/followers?type=count').then(checkStatus).then(res => res.json()),
    get('/proxy/newsfeed/follows?type=count').then(checkStatus).then(res => res.json()),
    get('/proxy/newsfeed/posts?type=count').then(checkStatus).then(res => res.json()),
    get('/proxy/user/newsfeed/likes').then(checkStatus).then(res => res.json()),
    get('/proxy/user/newsfeed/comments').then(checkStatus).then(res => res.json()),
  ])
    .spread((followersCount, followsCount, postsCount, likesCount, commentCount) => {
      dispatch({
        type: constants.GOT_META_DATA_COUNT,
        payload: {
          gotMetaDataCount: true,
          followersCount,
          followsCount,
          postsCount,
          likesCount,
          commentCount,
        },
      });
    })
    .catch(err => console.log('getMetaData ERROR::', err.stack));
};
export const updateProps = payload => ({ type: constants.UPDATE_PROPS, payload });
export const getPosts = () => (dispatch) => {
  dispatch(updateProps({ loading: true }));
  return get('/proxy/newsfeed/posts?type=list').then(checkStatus).then(res => res.json())
  .then(res => dispatch({ type: 'GOT_INITIAL_LOAD_NEWSFEED', payload: { list: res.posts } }))
  .catch(err => {
    console.log(err.stack);
    dispatch(updateProps({ loading: false }));
    dispatch({ type: 'GET_NEWSFEED_POSTS_FAILED' });
  });
};

export const getFollowers = () => (dispatch) => {
  dispatch(updateProps({ loading: true }));
  return get('/proxy/newsfeed/followers?type=list').then(checkStatus).then(res => res.json())
    .then(followers => dispatch(updateProps({ followers, loading: false })))
    .catch(err => {
      console.log(err.stack);
      dispatch(updateProps({ loading: false }));
      dispatch({ type: 'GET_NEWSFEED_FOLLOWERS_FAILED' });
    });
};

export const getFollows = () => (dispatch) => {
  dispatch(updateProps({ loading: true }));
  return get('/proxy/newsfeed/follows?type=list').then(checkStatus).then(res => res.json())
    .then(follows => dispatch(updateProps({ follows, loading: false })))
    .catch(err => {
      console.log(err.stack);
      dispatch(updateProps({ loading: false }));
      dispatch({ type: 'GET_NEWSFEED_FOLLOWERS_FAILED' });
    });
};



// WEBPACK FOOTER //
// ./src/app/stores/newsfeed/metaData/metaData-actions.js